module.exports = __webpack_public_path__ + "static/icon-index-480px-1930232ef5339fc09e181f118f3a9e2f.png";